import React, {Component} from 'react';
import {reverseParseTextView} from './createRender';
import {message} from 'antd'
import Draggable, {DraggableCore} from 'react-draggable'; 
import Footer from '../exercise/Footer';



const $ = require('$');
const MathQuill = require('MathQuill');

const MQ = MathQuill.getInterface(2);
const colorOption=['#00CD00','#FF6A6A','#4169E1','#FFC125','#FF1493','#FF7F24','#FF4500','#FFDEAD','#836FFF','#CD853F']

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }
    toggleAnswer = (val, e) => {
        e.stopPropagation();
        this.setState({visible: val});
    };
    componentDidMount() {
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                MQ.StaticMath(item);
            })

        if(this.props.data.subject==='0'){
            this.setState({visible:true})  //数学题默认答案显示
        }

    }


    componentDidUpdate(prevProps, prevState) {

        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });

    }

    createHtml = str => ({__html: str ? str : `&nbsp;`});
	formatData=()=>{
		let questionData={},
			parseData=reverseParseTextView(this.props.data)
		
		questionData=Object.assign(questionData,parseData)
		if(parseData.answer==='答案解析错误'){
            message.error('答案格式错误，无法正常解析')
            questionData.answer = [];
        }else{
        		questionData.answer=parseData.groupList.map(v=>v.answer)
        }
		return questionData
	}

	renderFillImg=()=>{

		let questionData=this.formatData()
		let {blankList,groupList,imgDetail}=questionData
		//处理挖空分组情况
		blankList.forEach((v,i1)=>{
			groupList.forEach((n,i2)=>{
				if(n.blank.includes(v.blankIndex+'')){
					v.groupIndex=n.groupIndex%10
				}
			})
		})
    		const dragHandlers = {
    			scale:1,
    			bounds:"parent",
    			disabled:true,
    			offsetParent: document.getElementById('offsetParent'),
    			enableUserSelectHack: false,
    		}
    		let blankItem=blankList.map((v,i)=>{
    			let blankColor=colorOption[v.groupIndex]
    			let blankStyle=v.isUse?{color:blankColor,border:`1px solid ${blankColor}`}:{}
    			return(
    				<Draggable
	    				key={i}
	    				position={{x:v.x*0.75,y:v.y*0.75}}
					{...dragHandlers}
			     >
			        <div style={blankStyle} className={`empty-item ${v.size}`}>空{i+1}</div>
			     </Draggable>
    			)
    		})
    			
		
    		
		return(
			<div id="offsetParent" className="img-blank-content">
                <div className="img-reverse" style={{width:'510px'}}>
                    <img src={imgDetail.imgUrl} width='100%'  height='auto'/>
                </div>
                 <div className="empty-list">
	                {blankItem}
	            </div>
            </div>
		)
		
	}

    render() {
        const {visible} = this.state;

        let originData = this.props.data;
        if(this.props.errorAnswer){originData.answer = this.props.errorAnswer}//题目检错页显示的是错的的答题答案
        const {num, children} = this.props;
  		
  		let questionData=this.formatData()
        
        return (
            <div className="box-exercise" ref={'viewer'}>
                <div className="exercise-content">
                    {num!=='undefined'&&<div className="exercise-num"><p className="math_text">{`${num + 1}、`}</p></div>}
                    <div className="exercise-con" dangerouslySetInnerHTML={this.createHtml(questionData.stem)}/>
                    {this.renderFillImg()}
                </div>
                <div className="exercise-footer">
                    {
                        visible &&
                        <div className="footer-hide relative">
                            <div>
                                <div className="inline-block"><span style={{fontSize: 14}}>{this.props.errorAnswer?'错误答案：':'正确答案：'}</span></div>
                                <div className="inline-block" style={{width: '80%'}}>
                                    <span style={{fontSize: 14}}  >
                                   		{
                                   			
                                   			questionData.answer.map((v,i)=><span key={i} style={{color:colorOption[i]}}>{v}、</span>)
                                   		}
                                   </span>
                                </div>
                            </div>
                            {
                                questionData.explain && <div>
                                    <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                    <div className="inline-block">
                                        <span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(questionData.explain)}/>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                            {
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={(e) => this.toggleAnswer(!visible,e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }

                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/enumeration/viewForView.js